import React, { useState } from 'react';
import { Control, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { Col } from 'reactstrap';
import { JobRequisitionDto } from '../../../../../../../services/applicant_tracking/JobRequisitionService/CreateJobRequisitionDto';
import { LabelledSelectFormHook } from '../../../../../../../components/LabelledSelectFormHook';
import useOptions from '../../../../../../../hooks/useOptions';
import { JobRequisitionReason } from '../../../../../../../entities/v1/applicant_tracking/JobRequisitionReason';
import { useJobRequisitionReasons } from '../../../../../../../queries/v1/applicant_tracking/useJobRequisitionReasons';
import { IconButton } from '../../../../../../../components/IconButton';
import { CreateRequisitionReasonModal } from './CreateRequisitionReasonModal';

interface PropTypes {
  formControl: Control<JobRequisitionDto>;
  getValues?: UseFormGetValues<JobRequisitionDto>;
  setValue?: UseFormSetValue<JobRequisitionDto>;
}

const jobRequisitionReasonToOption = (reason: JobRequisitionReason) => ({
  label: reason.name,
  value: reason.id.toString(),
});

export function Reason(props: PropTypes) {
  const {
    data: jobRequisitionReasons,
    refetch: refetchData,
    isLoading: isJobRequisitionReasonLoading,
  } = useJobRequisitionReasons(props.getValues('jobRequisitionReasonId'));

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <CreateRequisitionReasonModal
        isOpen={isModalOpen}
        refetchData={refetchData}
        setIsOpen={setIsModalOpen}
        setValue={props.setValue}
      />
      <Col xs={6}>
        <LabelledSelectFormHook<JobRequisitionDto>
          label='Reason'
          placeholder='Select Reason'
          isLoading={isJobRequisitionReasonLoading}
          formHookContext={{
            controllerName: 'jobRequisitionReasonId',
            formControl: props.formControl,
            required: true,
          }}
          options={useOptions(
            jobRequisitionReasons?.jobRequisitionReasons ?? [],
            jobRequisitionReasonToOption,
            jobRequisitionReasons?.jobRequisitionReasons?.find(
              (i) => i.id === props.getValues('jobRequisitionReasonId'),
            ),
          )}
        />
      </Col>
      <Col className='align-content-end' xs='auto'>
        <IconButton
          color='borderless'
          iconName='bi-plus-circle'
          buttonText='Create Requisition Reason'
          onClick={() => setIsModalOpen(true)}
        />
      </Col>
    </>
  );
}
